<template>
    <tr>
        <td>
            <i :class="`file-icon far fa-file ${getFileIcon(fileDetail.file.type)}`" v-if="fileDetail.file.type"></i>
        </td>
        <td>
            <input
                type="text"
                placeholder="Enter Name"
                class="form-control"
                :value="fileDetail.name"
                :disabled="uploading"
            />
        </td>
        <td class="form-group">
            <TypeaheadInput
                :data="searchedTypes"
                :value="selectedUploadType"
                v-on:valueChanged="uploadTypeChanged"
                placeholder="Start Typing..."
                :disabled="uploading"
                :showAllByDefault="true"
                :openOnFocus="true"
                v-on:blurredInput="v$.fileDetails[fileIndex].type.$touch()"
            ></TypeaheadInput>
            <span v-if="isFieldRequired(fileIndex)" class="field-invalid">Type is required.</span>
        </td>
        <td class="text-end">
            <button type="button" class="btn btn-xs btn-outline-danger" @click="removeFile()">
                <i class="fas fa-trash-alt"></i> Delete
            </button>
        </td>
    </tr>
</template>

<script lang="ts" src="./AddDocumentRow.ts"></script>
